<template>
  <main>
    <header>
      <i class="icon-you"></i>
      <h2>注册</h2>
    </header>
    <nav v-show="step === 0">
      <a><i class="icon-yonghu"></i><span>个人用户</span></a>
      <a><i class="icon-gongsi"></i><span>企业用户</span></a>
    </nav>
    <template v-if="step === 1">
      <ul>
        <li>
          <input type="tel" placeholder="请输入手机号码">
          <button>获取验证码</button>
        </li>
        <li>
          <input type="number" placeholder="请输入验证码"/>
        </li>
      </ul>
      <button class="next">下一步</button>
    </template>
    <template v-if="step === 2">
      <ul>
        <li>
          <input type="text" placeholder="昵称">
        </li>
        <li>
          <input type="password" placeholder="密码">
        </li>
        <li>
          <input type="password" placeholder="确认密码">
        </li>
        <li>
          <input type="text" placeholder="企业名称">
        </li>
        <li>
          <input type="text" placeholder="联系人">
        </li>
        <li>
          <input type="tel" placeholder="联系电话">
        </li>
        <li>
          <input type="text" placeholder="电子邮箱">
        </li>
        <li>
          <input type="tel" placeholder="推荐人手机">
        </li>
        <li>
          <input type="text" placeholder="请选择区域">
        </li>
        <li>
          <input type="text" placeholder="请输入详细地址"/>
        </li>
        <li>
          <input type="text" placeholder="请选择营业执照"/>
        </li>
      </ul>
      <button class="next">完成</button>
    </template>
  </main>
</template>

<script>
export default {
  components: {
  },
  data () {
    return {
      step: 2,
      china_citys: []
    }
  },
  created () {
    this.china_citys = window.china_citys;
    
  }
}
</script>

<style scoped src="./register.css"></style>